export const fullscreenModes = [
  "braze_modal",
  "classic_editor_expanded",
  "email_composer",
  "email_dnd_composer",
  "canvas_modal_edit",
  "canvas_fullscreen",
  "banner_composer",
  "iam_composer",
  "line_composer",
  "line_editor",
  "landing_pages_composer",
  "email_preference_center_composer",
  "content_block_composer",
  "content_block_dnd_composer",
  "subscription_page_composer",
  "email_footer_composer",
  "canvas_version_history",
  "canvas_test_mode",
  // Opened over a near-full-screen media-library picker modal; gets the same
  // full-height treatment so Operator uses the available vertical space.
  "media_library_modal",
] as const;

export type FullscreenMode = (typeof fullscreenModes)[number];

/**
 * Root class of the Operator panel. Exported for surfaces that must find the
 * panel in the DOM, such as a dialog that keeps it in its Tab cycle.
 */
export const agenticChatInterfaceClassName = "db-agentic-chat-interface";

/**
 * Surfaces that close on Escape and are mounted only while open: react-select menus, Beacon
 * poppers (popovers, menus, date pickers) and Beacon drawers. Hover tooltips are poppers too, but
 * nobody presses Escape to dismiss one, so they do not count.
 */
export const escapableSurfaceSelector = '.bcl-select__menu, .bcl-popper:not([role="tooltip"]), .bcl-drawer';

/**
 * Beacon modal dialogs stay mounted while closed, hidden with `display: none`.
 */
export const modalDialogSelector = ".bcl-modal-dialog";
